import { infoCatelogType } from "../interface/form";
import { OpenLoadingBarThunk } from "../redux/common/isLoading/thunk";
import moment from "moment";
import { axiosGet } from "./axios";
import { IRootThunkDispatch } from "../redux/store";
import {
    OpenSnackBarWithResultFail,
    OpenSnackBarWithResultSuccess,
} from "../redux/common/snackBar/thunk";

export async function handleDownLoadExcel(
    dispatch: IRootThunkDispatch,
    type: infoCatelogType,
    excelDownloadStartDate?: Date,
    excelDownloadEndDate?: Date
) {
    dispatch(OpenLoadingBarThunk(true));
    const excelDownloadStartDateString = moment(excelDownloadStartDate).format(
        "YYYY-MM-DD"
    );
    const excelDownloadEndDateString =
        moment(excelDownloadEndDate).format("YYYY-MM-DD");

    const result = await axiosGet(
        `/api/download/${type}?excelDownloadStartDate=${excelDownloadStartDateString}&excelDownloadEndDate=${excelDownloadEndDateString}`
    );
    if (result.data.success) {
        dispatch(OpenLoadingBarThunk(false));
        dispatch(OpenSnackBarWithResultSuccess(result.data.message));
        const fileUrl = process.env.REACT_APP_S3 + result.data.ExcelKey;
        const link = document.createElement("a");
        link.href = fileUrl;
        link.click();
    } else {
        dispatch(OpenLoadingBarThunk(false));
        dispatch(OpenSnackBarWithResultFail("未能下載Excel"));
    }
}
